import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const SPClientAnonymousApi = createApi({
  reducerPath: 'SPClientAnonymousApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_APIBaseUrl}/AnonymousDataGet/ExecuteJson/SPClientAnonymous`,
  }),
  tagTypes: ['ClientAnonymous'],
  endpoints: (builder) => ({
    getCountryList: builder.query({
      query: () => ({
        url: '12',
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
        },
        body: {},
      }),
      providesTags: ['ClientAnonymous'],
    }),
    getStateList: builder.query({
      query: () => ({
        url: '11',
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
        },
        body: {},
      }),
      providesTags: ['ClientAnonymous'],
    }),
  }),
});

export const { useGetCountryListQuery, useGetStateListQuery
 } = SPClientAnonymousApi;
export default SPClientAnonymousApi;
